const metaContent = metaName => document.querySelector(`meta[name=${metaName}]`).getAttribute('content');

export default metaContent;
